/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */

export type AdminMinuteProgramEnrollmentsListStateItem = typeof AdminMinuteProgramEnrollmentsListStateItem[keyof typeof AdminMinuteProgramEnrollmentsListStateItem];


export const AdminMinuteProgramEnrollmentsListStateItem = {
  active: 'active',
  approved: 'approved',
  interest_submitted: 'interest_submitted',
  rejected: 'rejected',
  started: 'started',
  unenrolled: 'unenrolled',
  withdrawn: 'withdrawn',
} as const;
